import "./App.css";
import MainNavigator from "./Components/Navigators/MainNavigator";
import LoginScreen from "./Components/Views/AuthModule/LoginScreen";
import { PersistGate } from "redux-persist/integration/react";
import { Provider, useSelector } from "react-redux";
import store, { persistor } from "./store/store";
import { Toaster } from "react-hot-toast";

function App() {
  console.log(process.env.REACT_APP_APP_CONFIG, "<<< app config");

  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Toaster position="top-right" />
          <AppRoute />
        </PersistGate>
      </Provider>
    </div>
  );
}

const AppRoute = () => {
  const user = useSelector(state => state.auth.user);

  if (user) return <MainNavigator />;
  else return <LoginScreen />;
};

export default App;

// creds
// test@gmail.com
// test1234
